import PropTypes from 'prop-types'

const InlineButton = ({ text, action, variant = 'primary', disabled, onAction }) => {
  const handleClick = () => {
    if (!disabled && onAction) {
      onAction(action, { componentType: 'button', text })
    }
  }

  const getVariantStyles = (variant) => {
    const styles = {
      primary: 'bg-blue-600 hover:bg-blue-500 text-white focus:ring-blue-500',
      secondary: 'bg-gray-600 hover:bg-gray-500 text-white focus:ring-gray-500',
      success: 'bg-green-600 hover:bg-green-500 text-white focus:ring-green-500',
      danger: 'bg-red-600 hover:bg-red-500 text-white focus:ring-red-500',
      outline: 'border border-gray-600 hover:bg-gray-700 text-gray-300 focus:ring-gray-500',
    }
    return styles[variant] || styles.primary
  }

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`
        inline-flex items-center px-3 py-1 text-sm font-medium rounded-md
        transition-colors duration-200 focus:outline-none focus:ring-2
        ${getVariantStyles(variant)}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
      `}
    >
      {text}
    </button>
  )
}

InlineButton.propTypes = {
  text: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'outline']),
  disabled: PropTypes.bool,
  onAction: PropTypes.func.isRequired,
}

export default InlineButton
